/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ApprovedRouteImport } from './routes/approved'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ComingSoonRouteImport } from './routes/coming-soon'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as FileOverviewRouteImport } from './routes/file-overview'
import { Route as JobQueueRouteImport } from './routes/job-queue'
import { Route as MetaSearchRouteImport } from './routes/meta-search'
import { Route as PendingRouteImport } from './routes/pending'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SystemRouteImport } from './routes/system'
import { Route as TeamsRouteImport } from './routes/teams'
import { Route as Transition360RouteRouteImport } from './routes/transition-360/route'
import { Route as AircraftsIndexRouteImport } from './routes/aircrafts/index'
import { Route as AssetBinderIndexRouteImport } from './routes/asset-binder/index'
import { Route as Asset_collectionIndexRouteImport } from './routes/asset_collection/index'
import { Route as Asset_collectionCreate_assetRouteImport } from './routes/asset_collection/create_asset'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'
import { Route as DocumentsIngestionFunnelRouteImport } from './routes/documents/ingestion-funnel'
import { Route as GroundTruthIndexRouteImport } from './routes/ground-truth/index'
import { Route as GroundTruthFieldsRouteImport } from './routes/ground-truth/fields'
import { Route as GroundTruthSnapshotsRouteImport } from './routes/ground-truth/snapshots'
import { Route as IataBinderIndexRouteImport } from './routes/iata-binder/index'
import { Route as LeaseIndexRouteImport } from './routes/lease/index'
import { Route as LeaseAddContractRouteImport } from './routes/lease/add-contract'
import { Route as LeaseAircraftRouteImport } from './routes/lease/aircraft'
import { Route as LeaseConnectApiRouteImport } from './routes/lease/connect-api'
import { Route as LeaseCreateProjectRouteImport } from './routes/lease/create-project'
import { Route as Line_itemsIndexRouteImport } from './routes/line_items/index'
import { Route as Removal_installation_listIndexRouteImport } from './routes/removal_installation_list/index'
import { Route as Transition360IndexRouteImport } from './routes/transition-360/index'
import { Route as AircraftsAircraftIdIndexRouteImport } from './routes/aircrafts/$aircraftId/index'
import { Route as AircraftsAircraftIdWorkOrderUploadRouteImport } from './routes/aircrafts/$aircraftId/work-order-upload'
import { Route as DocumentsDuplicateReviewIndexRouteImport } from './routes/documents/duplicate-review/index'
import { Route as DocumentsUploadIndexRouteImport } from './routes/documents/upload/index'
import { Route as GroundTruthIngestedFileIdIndexRouteImport } from './routes/ground-truth/$ingestedFileId/index'
import { Route as GroundTruthIngestedFileIdPagesRouteImport } from './routes/ground-truth/$ingestedFileId/pages'
import { Route as GroundTruthIngestedFileIdSheetsRouteImport } from './routes/ground-truth/$ingestedFileId/sheets'
import { Route as Line_itemsLineItemIdIndexRouteImport } from './routes/line_items/$lineItemId/index'
import { Route as Removal_installation_listComponentActivityIdIndexRouteImport } from './routes/removal_installation_list/$componentActivityId/index'
import { Route as Asset_collectionCollectionIdAssetsIndexRouteImport } from './routes/asset_collection/$collectionId/assets/index'
import { Route as Asset_collectionAssetsAssetIdIndexRouteImport } from './routes/asset_collection/assets/$assetId/index'
import { Route as DocumentsDuplicateReviewIdIndexRouteImport } from './routes/documents/duplicate-review/$id/index'
import { Route as GroundTruthIngestedFileIdDocIdIndexRouteImport } from './routes/ground-truth/$ingestedFileId/$docId/index'
import { Route as GroundTruthIngestedFileIdDocIdRowsRouteImport } from './routes/ground-truth/$ingestedFileId/$docId/rows'
import { Route as IataBinderProjectsProjectIdPageRouteImport } from './routes/iata-binder/projects/$projectId/page'
import { Route as IataBinderProjectsProjectIdUploadRouteImport } from './routes/iata-binder/projects/$projectId/upload'
import { Route as LeaseDocumentsDocumentIdPageRouteImport } from './routes/lease/documents/$documentId/page'
import { Route as LeaseProjectsProjectIdAdTableRouteImport } from './routes/lease/projects/$projectId/ad-table'
import { Route as LeaseProjectsProjectIdAircraftFolderRouteImport } from './routes/lease/projects/$projectId/aircraft-folder'
import { Route as LeaseProjectsProjectIdPageRouteImport } from './routes/lease/projects/$projectId/page'
import { Route as LeaseProjectsProjectIdReportsRouteImport } from './routes/lease/projects/$projectId/reports'
import { Route as Transition360ProjectsProjectIdIndexRouteImport } from './routes/transition-360/projects/$projectId/index'
import { Route as AircraftsAircraftIdWork_ordersWorkOrderIdIndexRouteImport } from './routes/aircrafts/$aircraftId/work_orders/$workOrderId/index'
import { Route as IataBinderProjectsProjectIdAdReportIndexRouteImport } from './routes/iata-binder/projects/$projectId/ad-report/index'
import { Route as LeaseProjectsProjectIdDocumentsIndexRouteImport } from './routes/lease/projects/$projectId/documents/index'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/route'
import { Route as Transition360ProjectsProjectIdDocumentsDocumentIdRouteImport } from './routes/transition-360/projects/$projectId/documents/$documentId'
import { Route as Asset_collectionAssetsAssetIdProjectsProjectIdIndexRouteImport } from './routes/asset_collection/assets/$assetId/projects/$projectId/index'
import { Route as Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRouteImport } from './routes/asset_collection/assets/$assetId/projects/$projectId/edit-asset'
import { Route as IataBinderProjectsProjectIdBtbSerialNumberIndexRouteImport } from './routes/iata-binder/projects/$projectId/btb/$serialNumber/index'
import { Route as IataBinderProjectsProjectIdFoldersFolderLetterIndexRouteImport } from './routes/iata-binder/projects/$projectId/folders/$folderLetter/index'
import { Route as LeaseProjectsProjectIdComponentsPartNumberPageRouteImport } from './routes/lease/projects/$projectId/components/$partNumber/page'
import { Route as LeaseProjectsProjectIdDocumentsDocumentIdPageRouteImport } from './routes/lease/projects/$projectId/documents/$documentId/page'
import { Route as LeaseProjectsProjectIdFoldersFolderLetterIndexRouteImport } from './routes/lease/projects/$projectId/folders/$folderLetter/index'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/index'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/binder'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/labels'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/open-items'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/repository'
import { Route as Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRouteImport } from './routes/asset_collection/$collectionId/assets/$assetId/projects/$projectId/index'
import { Route as Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRouteImport } from './routes/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset'
import { Route as Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRouteImport } from './routes/asset_collection/assets/$assetId/projects/$projectId/search/index'
import { Route as Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRouteImport } from './routes/asset_collection/assets/$assetId/projects/$projectId/search/$docId'
import { Route as IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRouteImport } from './routes/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/index'
import { Route as LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRouteImport } from './routes/lease/projects/$projectId/folders/$folderLetter/subfolder/index'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/index'
import { Route as Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRouteImport } from './routes/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId'
import { Route as Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRouteImport } from './routes/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/index'
import { Route as Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRouteImport } from './routes/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId'
import { Route as Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRouteImport } from './routes/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/index'
import { Route as Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRouteImport } from './routes/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/index'
import { Route as Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRouteImport } from './routes/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/index'
import { Route as Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRouteImport } from './routes/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/index'
import { Route as Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRouteImport } from './routes/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/index'
import { Route as Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRouteImport } from './routes/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovedRoute = ApprovedRouteImport.update({
  id: '/approved',
  path: '/approved',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ComingSoonRoute = ComingSoonRouteImport.update({
  id: '/coming-soon',
  path: '/coming-soon',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const FileOverviewRoute = FileOverviewRouteImport.update({
  id: '/file-overview',
  path: '/file-overview',
  getParentRoute: () => rootRouteImport,
} as any)
const JobQueueRoute = JobQueueRouteImport.update({
  id: '/job-queue',
  path: '/job-queue',
  getParentRoute: () => rootRouteImport,
} as any)
const MetaSearchRoute = MetaSearchRouteImport.update({
  id: '/meta-search',
  path: '/meta-search',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingRoute = PendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemRoute = SystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsRoute = TeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => rootRouteImport,
} as any)
const Transition360RouteRoute = Transition360RouteRouteImport.update({
  id: '/transition-360',
  path: '/transition-360',
  getParentRoute: () => rootRouteImport,
} as any)
const AircraftsIndexRoute = AircraftsIndexRouteImport.update({
  id: '/aircrafts/',
  path: '/aircrafts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetBinderIndexRoute = AssetBinderIndexRouteImport.update({
  id: '/asset-binder/',
  path: '/asset-binder/',
  getParentRoute: () => rootRouteImport,
} as any)
const Asset_collectionIndexRoute = Asset_collectionIndexRouteImport.update({
  id: '/asset_collection/',
  path: '/asset_collection/',
  getParentRoute: () => rootRouteImport,
} as any)
const Asset_collectionCreate_assetRoute =
  Asset_collectionCreate_assetRouteImport.update({
    id: '/asset_collection/create_asset',
    path: '/asset_collection/create_asset',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIngestionFunnelRoute =
  DocumentsIngestionFunnelRouteImport.update({
    id: '/documents/ingestion-funnel',
    path: '/documents/ingestion-funnel',
    getParentRoute: () => rootRouteImport,
  } as any)
const GroundTruthIndexRoute = GroundTruthIndexRouteImport.update({
  id: '/ground-truth/',
  path: '/ground-truth/',
  getParentRoute: () => rootRouteImport,
} as any)
const GroundTruthFieldsRoute = GroundTruthFieldsRouteImport.update({
  id: '/ground-truth/fields',
  path: '/ground-truth/fields',
  getParentRoute: () => rootRouteImport,
} as any)
const GroundTruthSnapshotsRoute = GroundTruthSnapshotsRouteImport.update({
  id: '/ground-truth/snapshots',
  path: '/ground-truth/snapshots',
  getParentRoute: () => rootRouteImport,
} as any)
const IataBinderIndexRoute = IataBinderIndexRouteImport.update({
  id: '/iata-binder/',
  path: '/iata-binder/',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaseIndexRoute = LeaseIndexRouteImport.update({
  id: '/lease/',
  path: '/lease/',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaseAddContractRoute = LeaseAddContractRouteImport.update({
  id: '/lease/add-contract',
  path: '/lease/add-contract',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaseAircraftRoute = LeaseAircraftRouteImport.update({
  id: '/lease/aircraft',
  path: '/lease/aircraft',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaseConnectApiRoute = LeaseConnectApiRouteImport.update({
  id: '/lease/connect-api',
  path: '/lease/connect-api',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaseCreateProjectRoute = LeaseCreateProjectRouteImport.update({
  id: '/lease/create-project',
  path: '/lease/create-project',
  getParentRoute: () => rootRouteImport,
} as any)
const Line_itemsIndexRoute = Line_itemsIndexRouteImport.update({
  id: '/line_items/',
  path: '/line_items/',
  getParentRoute: () => rootRouteImport,
} as any)
const Removal_installation_listIndexRoute =
  Removal_installation_listIndexRouteImport.update({
    id: '/removal_installation_list/',
    path: '/removal_installation_list/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Transition360IndexRoute = Transition360IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Transition360RouteRoute,
} as any)
const AircraftsAircraftIdIndexRoute =
  AircraftsAircraftIdIndexRouteImport.update({
    id: '/aircrafts/$aircraftId/',
    path: '/aircrafts/$aircraftId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AircraftsAircraftIdWorkOrderUploadRoute =
  AircraftsAircraftIdWorkOrderUploadRouteImport.update({
    id: '/aircrafts/$aircraftId/work-order-upload',
    path: '/aircrafts/$aircraftId/work-order-upload',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsDuplicateReviewIndexRoute =
  DocumentsDuplicateReviewIndexRouteImport.update({
    id: '/documents/duplicate-review/',
    path: '/documents/duplicate-review/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsUploadIndexRoute = DocumentsUploadIndexRouteImport.update({
  id: '/documents/upload/',
  path: '/documents/upload/',
  getParentRoute: () => rootRouteImport,
} as any)
const GroundTruthIngestedFileIdIndexRoute =
  GroundTruthIngestedFileIdIndexRouteImport.update({
    id: '/ground-truth/$ingestedFileId/',
    path: '/ground-truth/$ingestedFileId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const GroundTruthIngestedFileIdPagesRoute =
  GroundTruthIngestedFileIdPagesRouteImport.update({
    id: '/ground-truth/$ingestedFileId/pages',
    path: '/ground-truth/$ingestedFileId/pages',
    getParentRoute: () => rootRouteImport,
  } as any)
const GroundTruthIngestedFileIdSheetsRoute =
  GroundTruthIngestedFileIdSheetsRouteImport.update({
    id: '/ground-truth/$ingestedFileId/sheets',
    path: '/ground-truth/$ingestedFileId/sheets',
    getParentRoute: () => rootRouteImport,
  } as any)
const Line_itemsLineItemIdIndexRoute =
  Line_itemsLineItemIdIndexRouteImport.update({
    id: '/line_items/$lineItemId/',
    path: '/line_items/$lineItemId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Removal_installation_listComponentActivityIdIndexRoute =
  Removal_installation_listComponentActivityIdIndexRouteImport.update({
    id: '/removal_installation_list/$componentActivityId/',
    path: '/removal_installation_list/$componentActivityId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Asset_collectionCollectionIdAssetsIndexRoute =
  Asset_collectionCollectionIdAssetsIndexRouteImport.update({
    id: '/asset_collection/$collectionId/assets/',
    path: '/asset_collection/$collectionId/assets/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Asset_collectionAssetsAssetIdIndexRoute =
  Asset_collectionAssetsAssetIdIndexRouteImport.update({
    id: '/asset_collection/assets/$assetId/',
    path: '/asset_collection/assets/$assetId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsDuplicateReviewIdIndexRoute =
  DocumentsDuplicateReviewIdIndexRouteImport.update({
    id: '/documents/duplicate-review/$id/',
    path: '/documents/duplicate-review/$id/',
    getParentRoute: () => rootRouteImport,
  } as any)
const GroundTruthIngestedFileIdDocIdIndexRoute =
  GroundTruthIngestedFileIdDocIdIndexRouteImport.update({
    id: '/ground-truth/$ingestedFileId/$docId/',
    path: '/ground-truth/$ingestedFileId/$docId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const GroundTruthIngestedFileIdDocIdRowsRoute =
  GroundTruthIngestedFileIdDocIdRowsRouteImport.update({
    id: '/ground-truth/$ingestedFileId/$docId/rows',
    path: '/ground-truth/$ingestedFileId/$docId/rows',
    getParentRoute: () => rootRouteImport,
  } as any)
const IataBinderProjectsProjectIdPageRoute =
  IataBinderProjectsProjectIdPageRouteImport.update({
    id: '/iata-binder/projects/$projectId/page',
    path: '/iata-binder/projects/$projectId/page',
    getParentRoute: () => rootRouteImport,
  } as any)
const IataBinderProjectsProjectIdUploadRoute =
  IataBinderProjectsProjectIdUploadRouteImport.update({
    id: '/iata-binder/projects/$projectId/upload',
    path: '/iata-binder/projects/$projectId/upload',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseDocumentsDocumentIdPageRoute =
  LeaseDocumentsDocumentIdPageRouteImport.update({
    id: '/lease/documents/$documentId/page',
    path: '/lease/documents/$documentId/page',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdAdTableRoute =
  LeaseProjectsProjectIdAdTableRouteImport.update({
    id: '/lease/projects/$projectId/ad-table',
    path: '/lease/projects/$projectId/ad-table',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdAircraftFolderRoute =
  LeaseProjectsProjectIdAircraftFolderRouteImport.update({
    id: '/lease/projects/$projectId/aircraft-folder',
    path: '/lease/projects/$projectId/aircraft-folder',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdPageRoute =
  LeaseProjectsProjectIdPageRouteImport.update({
    id: '/lease/projects/$projectId/page',
    path: '/lease/projects/$projectId/page',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdReportsRoute =
  LeaseProjectsProjectIdReportsRouteImport.update({
    id: '/lease/projects/$projectId/reports',
    path: '/lease/projects/$projectId/reports',
    getParentRoute: () => rootRouteImport,
  } as any)
const Transition360ProjectsProjectIdIndexRoute =
  Transition360ProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => Transition360RouteRoute,
  } as any)
const AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute =
  AircraftsAircraftIdWork_ordersWorkOrderIdIndexRouteImport.update({
    id: '/aircrafts/$aircraftId/work_orders/$workOrderId/',
    path: '/aircrafts/$aircraftId/work_orders/$workOrderId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const IataBinderProjectsProjectIdAdReportIndexRoute =
  IataBinderProjectsProjectIdAdReportIndexRouteImport.update({
    id: '/iata-binder/projects/$projectId/ad-report/',
    path: '/iata-binder/projects/$projectId/ad-report/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdDocumentsIndexRoute =
  LeaseProjectsProjectIdDocumentsIndexRouteImport.update({
    id: '/lease/projects/$projectId/documents/',
    path: '/lease/projects/$projectId/documents/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteImport.update({
    id: '/projects/$projectId/assets/$projectAssetId',
    path: '/projects/$projectId/assets/$projectAssetId',
    getParentRoute: () => Transition360RouteRoute,
  } as any)
const Transition360ProjectsProjectIdDocumentsDocumentIdRoute =
  Transition360ProjectsProjectIdDocumentsDocumentIdRouteImport.update({
    id: '/projects/$projectId/documents/$documentId',
    path: '/projects/$projectId/documents/$documentId',
    getParentRoute: () => Transition360RouteRoute,
  } as any)
const Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute =
  Asset_collectionAssetsAssetIdProjectsProjectIdIndexRouteImport.update({
    id: '/asset_collection/assets/$assetId/projects/$projectId/',
    path: '/asset_collection/assets/$assetId/projects/$projectId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute =
  Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRouteImport.update({
    id: '/asset_collection/assets/$assetId/projects/$projectId/edit-asset',
    path: '/asset_collection/assets/$assetId/projects/$projectId/edit-asset',
    getParentRoute: () => rootRouteImport,
  } as any)
const IataBinderProjectsProjectIdBtbSerialNumberIndexRoute =
  IataBinderProjectsProjectIdBtbSerialNumberIndexRouteImport.update({
    id: '/iata-binder/projects/$projectId/btb/$serialNumber/',
    path: '/iata-binder/projects/$projectId/btb/$serialNumber/',
    getParentRoute: () => rootRouteImport,
  } as any)
const IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute =
  IataBinderProjectsProjectIdFoldersFolderLetterIndexRouteImport.update({
    id: '/iata-binder/projects/$projectId/folders/$folderLetter/',
    path: '/iata-binder/projects/$projectId/folders/$folderLetter/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdComponentsPartNumberPageRoute =
  LeaseProjectsProjectIdComponentsPartNumberPageRouteImport.update({
    id: '/lease/projects/$projectId/components/$partNumber/page',
    path: '/lease/projects/$projectId/components/$partNumber/page',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdDocumentsDocumentIdPageRoute =
  LeaseProjectsProjectIdDocumentsDocumentIdPageRouteImport.update({
    id: '/lease/projects/$projectId/documents/$documentId/page',
    path: '/lease/projects/$projectId/documents/$documentId/page',
    getParentRoute: () => rootRouteImport,
  } as any)
const LeaseProjectsProjectIdFoldersFolderLetterIndexRoute =
  LeaseProjectsProjectIdFoldersFolderLetterIndexRouteImport.update({
    id: '/lease/projects/$projectId/folders/$folderLetter/',
    path: '/lease/projects/$projectId/folders/$folderLetter/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute,
  } as any)
const Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRouteImport.update({
    id: '/binder',
    path: '/binder',
    getParentRoute: () =>
      Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute,
  } as any)
const Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () =>
      Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute,
  } as any)
const Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRouteImport.update(
    {
      id: '/open-items',
      path: '/open-items',
      getParentRoute: () =>
        Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute,
    } as any,
  )
const Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRouteImport.update(
    {
      id: '/repository',
      path: '/repository',
      getParentRoute: () =>
        Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute,
    } as any,
  )
const Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute =
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRouteImport.update(
    {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/',
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute =
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRouteImport.update(
    {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset',
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute =
  Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRouteImport.update({
    id: '/asset_collection/assets/$assetId/projects/$projectId/search/',
    path: '/asset_collection/assets/$assetId/projects/$projectId/search/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute =
  Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRouteImport.update({
    id: '/asset_collection/assets/$assetId/projects/$projectId/search/$docId',
    path: '/asset_collection/assets/$assetId/projects/$projectId/search/$docId',
    getParentRoute: () => rootRouteImport,
  } as any)
const IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute =
  IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRouteImport.update(
    {
      id: '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/',
      path: '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute =
  LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRouteImport.update({
    id: '/lease/projects/$projectId/folders/$folderLetter/subfolder/',
    path: '/lease/projects/$projectId/folders/$folderLetter/subfolder/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRouteImport.update(
    {
      id: '/status-reports/',
      path: '/status-reports/',
      getParentRoute: () =>
        Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute,
    } as any,
  )
const Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute =
  Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRouteImport.update(
    {
      id: '/status-reports/$statusReportId',
      path: '/status-reports/$statusReportId',
      getParentRoute: () =>
        Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute,
    } as any,
  )
const Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute =
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRouteImport.update(
    {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/',
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute =
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRouteImport.update(
    {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId',
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute =
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRouteImport.update(
    {
      id: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/',
      path: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute =
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRouteImport.update(
    {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/',
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute =
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRouteImport.update(
    {
      id: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/',
      path: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute =
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRouteImport.update(
    {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/',
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute =
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRouteImport.update(
    {
      id: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/',
      path: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute =
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRouteImport.update(
    {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/',
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/transition-360': typeof Transition360RouteRouteWithChildren
  '/approved': typeof ApprovedRoute
  '/auth': typeof AuthRoute
  '/coming-soon': typeof ComingSoonRoute
  '/feedback': typeof FeedbackRoute
  '/file-overview': typeof FileOverviewRoute
  '/job-queue': typeof JobQueueRoute
  '/meta-search': typeof MetaSearchRoute
  '/pending': typeof PendingRoute
  '/settings': typeof SettingsRoute
  '/system': typeof SystemRoute
  '/teams': typeof TeamsRoute
  '/asset_collection/create_asset': typeof Asset_collectionCreate_assetRoute
  '/documents/ingestion-funnel': typeof DocumentsIngestionFunnelRoute
  '/ground-truth/fields': typeof GroundTruthFieldsRoute
  '/ground-truth/snapshots': typeof GroundTruthSnapshotsRoute
  '/lease/add-contract': typeof LeaseAddContractRoute
  '/lease/aircraft': typeof LeaseAircraftRoute
  '/lease/connect-api': typeof LeaseConnectApiRoute
  '/lease/create-project': typeof LeaseCreateProjectRoute
  '/aircrafts/': typeof AircraftsIndexRoute
  '/asset-binder/': typeof AssetBinderIndexRoute
  '/asset_collection/': typeof Asset_collectionIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/ground-truth/': typeof GroundTruthIndexRoute
  '/iata-binder/': typeof IataBinderIndexRoute
  '/lease/': typeof LeaseIndexRoute
  '/line_items/': typeof Line_itemsIndexRoute
  '/removal_installation_list/': typeof Removal_installation_listIndexRoute
  '/transition-360/': typeof Transition360IndexRoute
  '/aircrafts/$aircraftId/work-order-upload': typeof AircraftsAircraftIdWorkOrderUploadRoute
  '/ground-truth/$ingestedFileId/pages': typeof GroundTruthIngestedFileIdPagesRoute
  '/ground-truth/$ingestedFileId/sheets': typeof GroundTruthIngestedFileIdSheetsRoute
  '/aircrafts/$aircraftId/': typeof AircraftsAircraftIdIndexRoute
  '/documents/duplicate-review/': typeof DocumentsDuplicateReviewIndexRoute
  '/documents/upload/': typeof DocumentsUploadIndexRoute
  '/ground-truth/$ingestedFileId/': typeof GroundTruthIngestedFileIdIndexRoute
  '/line_items/$lineItemId/': typeof Line_itemsLineItemIdIndexRoute
  '/removal_installation_list/$componentActivityId/': typeof Removal_installation_listComponentActivityIdIndexRoute
  '/ground-truth/$ingestedFileId/$docId/rows': typeof GroundTruthIngestedFileIdDocIdRowsRoute
  '/iata-binder/projects/$projectId/page': typeof IataBinderProjectsProjectIdPageRoute
  '/iata-binder/projects/$projectId/upload': typeof IataBinderProjectsProjectIdUploadRoute
  '/lease/documents/$documentId/page': typeof LeaseDocumentsDocumentIdPageRoute
  '/lease/projects/$projectId/ad-table': typeof LeaseProjectsProjectIdAdTableRoute
  '/lease/projects/$projectId/aircraft-folder': typeof LeaseProjectsProjectIdAircraftFolderRoute
  '/lease/projects/$projectId/page': typeof LeaseProjectsProjectIdPageRoute
  '/lease/projects/$projectId/reports': typeof LeaseProjectsProjectIdReportsRoute
  '/asset_collection/$collectionId/assets/': typeof Asset_collectionCollectionIdAssetsIndexRoute
  '/asset_collection/assets/$assetId/': typeof Asset_collectionAssetsAssetIdIndexRoute
  '/documents/duplicate-review/$id/': typeof DocumentsDuplicateReviewIdIndexRoute
  '/ground-truth/$ingestedFileId/$docId/': typeof GroundTruthIngestedFileIdDocIdIndexRoute
  '/transition-360/projects/$projectId/': typeof Transition360ProjectsProjectIdIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteWithChildren
  '/transition-360/projects/$projectId/documents/$documentId': typeof Transition360ProjectsProjectIdDocumentsDocumentIdRoute
  '/aircrafts/$aircraftId/work_orders/$workOrderId/': typeof AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute
  '/iata-binder/projects/$projectId/ad-report/': typeof IataBinderProjectsProjectIdAdReportIndexRoute
  '/lease/projects/$projectId/documents/': typeof LeaseProjectsProjectIdDocumentsIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/edit-asset': typeof Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute
  '/lease/projects/$projectId/components/$partNumber/page': typeof LeaseProjectsProjectIdComponentsPartNumberPageRoute
  '/lease/projects/$projectId/documents/$documentId/page': typeof LeaseProjectsProjectIdDocumentsDocumentIdPageRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/binder': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/labels': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/open-items': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/repository': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute
  '/asset_collection/assets/$assetId/projects/$projectId/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute
  '/iata-binder/projects/$projectId/btb/$serialNumber/': typeof IataBinderProjectsProjectIdBtbSerialNumberIndexRoute
  '/iata-binder/projects/$projectId/folders/$folderLetter/': typeof IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute
  '/lease/projects/$projectId/folders/$folderLetter/': typeof LeaseProjectsProjectIdFoldersFolderLetterIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute
  '/asset_collection/assets/$assetId/projects/$projectId/search/$docId': typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/search/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute
  '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/': typeof IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  '/lease/projects/$projectId/folders/$folderLetter/subfolder/': typeof LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/approved': typeof ApprovedRoute
  '/auth': typeof AuthRoute
  '/coming-soon': typeof ComingSoonRoute
  '/feedback': typeof FeedbackRoute
  '/file-overview': typeof FileOverviewRoute
  '/job-queue': typeof JobQueueRoute
  '/meta-search': typeof MetaSearchRoute
  '/pending': typeof PendingRoute
  '/settings': typeof SettingsRoute
  '/system': typeof SystemRoute
  '/teams': typeof TeamsRoute
  '/asset_collection/create_asset': typeof Asset_collectionCreate_assetRoute
  '/documents/ingestion-funnel': typeof DocumentsIngestionFunnelRoute
  '/ground-truth/fields': typeof GroundTruthFieldsRoute
  '/ground-truth/snapshots': typeof GroundTruthSnapshotsRoute
  '/lease/add-contract': typeof LeaseAddContractRoute
  '/lease/aircraft': typeof LeaseAircraftRoute
  '/lease/connect-api': typeof LeaseConnectApiRoute
  '/lease/create-project': typeof LeaseCreateProjectRoute
  '/aircrafts': typeof AircraftsIndexRoute
  '/asset-binder': typeof AssetBinderIndexRoute
  '/asset_collection': typeof Asset_collectionIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/ground-truth': typeof GroundTruthIndexRoute
  '/iata-binder': typeof IataBinderIndexRoute
  '/lease': typeof LeaseIndexRoute
  '/line_items': typeof Line_itemsIndexRoute
  '/removal_installation_list': typeof Removal_installation_listIndexRoute
  '/transition-360': typeof Transition360IndexRoute
  '/aircrafts/$aircraftId/work-order-upload': typeof AircraftsAircraftIdWorkOrderUploadRoute
  '/ground-truth/$ingestedFileId/pages': typeof GroundTruthIngestedFileIdPagesRoute
  '/ground-truth/$ingestedFileId/sheets': typeof GroundTruthIngestedFileIdSheetsRoute
  '/aircrafts/$aircraftId': typeof AircraftsAircraftIdIndexRoute
  '/documents/duplicate-review': typeof DocumentsDuplicateReviewIndexRoute
  '/documents/upload': typeof DocumentsUploadIndexRoute
  '/ground-truth/$ingestedFileId': typeof GroundTruthIngestedFileIdIndexRoute
  '/line_items/$lineItemId': typeof Line_itemsLineItemIdIndexRoute
  '/removal_installation_list/$componentActivityId': typeof Removal_installation_listComponentActivityIdIndexRoute
  '/ground-truth/$ingestedFileId/$docId/rows': typeof GroundTruthIngestedFileIdDocIdRowsRoute
  '/iata-binder/projects/$projectId/page': typeof IataBinderProjectsProjectIdPageRoute
  '/iata-binder/projects/$projectId/upload': typeof IataBinderProjectsProjectIdUploadRoute
  '/lease/documents/$documentId/page': typeof LeaseDocumentsDocumentIdPageRoute
  '/lease/projects/$projectId/ad-table': typeof LeaseProjectsProjectIdAdTableRoute
  '/lease/projects/$projectId/aircraft-folder': typeof LeaseProjectsProjectIdAircraftFolderRoute
  '/lease/projects/$projectId/page': typeof LeaseProjectsProjectIdPageRoute
  '/lease/projects/$projectId/reports': typeof LeaseProjectsProjectIdReportsRoute
  '/asset_collection/$collectionId/assets': typeof Asset_collectionCollectionIdAssetsIndexRoute
  '/asset_collection/assets/$assetId': typeof Asset_collectionAssetsAssetIdIndexRoute
  '/documents/duplicate-review/$id': typeof DocumentsDuplicateReviewIdIndexRoute
  '/ground-truth/$ingestedFileId/$docId': typeof GroundTruthIngestedFileIdDocIdIndexRoute
  '/transition-360/projects/$projectId': typeof Transition360ProjectsProjectIdIndexRoute
  '/transition-360/projects/$projectId/documents/$documentId': typeof Transition360ProjectsProjectIdDocumentsDocumentIdRoute
  '/aircrafts/$aircraftId/work_orders/$workOrderId': typeof AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute
  '/iata-binder/projects/$projectId/ad-report': typeof IataBinderProjectsProjectIdAdReportIndexRoute
  '/lease/projects/$projectId/documents': typeof LeaseProjectsProjectIdDocumentsIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/edit-asset': typeof Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute
  '/lease/projects/$projectId/components/$partNumber/page': typeof LeaseProjectsProjectIdComponentsPartNumberPageRoute
  '/lease/projects/$projectId/documents/$documentId/page': typeof LeaseProjectsProjectIdDocumentsDocumentIdPageRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/binder': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/labels': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/open-items': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/repository': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute
  '/asset_collection/assets/$assetId/projects/$projectId': typeof Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute
  '/iata-binder/projects/$projectId/btb/$serialNumber': typeof IataBinderProjectsProjectIdBtbSerialNumberIndexRoute
  '/iata-binder/projects/$projectId/folders/$folderLetter': typeof IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute
  '/lease/projects/$projectId/folders/$folderLetter': typeof LeaseProjectsProjectIdFoldersFolderLetterIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute
  '/asset_collection/assets/$assetId/projects/$projectId/search/$docId': typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/search': typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute
  '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder': typeof IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  '/lease/projects/$projectId/folders/$folderLetter/subfolder': typeof LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/transition-360': typeof Transition360RouteRouteWithChildren
  '/approved': typeof ApprovedRoute
  '/auth': typeof AuthRoute
  '/coming-soon': typeof ComingSoonRoute
  '/feedback': typeof FeedbackRoute
  '/file-overview': typeof FileOverviewRoute
  '/job-queue': typeof JobQueueRoute
  '/meta-search': typeof MetaSearchRoute
  '/pending': typeof PendingRoute
  '/settings': typeof SettingsRoute
  '/system': typeof SystemRoute
  '/teams': typeof TeamsRoute
  '/asset_collection/create_asset': typeof Asset_collectionCreate_assetRoute
  '/documents/ingestion-funnel': typeof DocumentsIngestionFunnelRoute
  '/ground-truth/fields': typeof GroundTruthFieldsRoute
  '/ground-truth/snapshots': typeof GroundTruthSnapshotsRoute
  '/lease/add-contract': typeof LeaseAddContractRoute
  '/lease/aircraft': typeof LeaseAircraftRoute
  '/lease/connect-api': typeof LeaseConnectApiRoute
  '/lease/create-project': typeof LeaseCreateProjectRoute
  '/aircrafts/': typeof AircraftsIndexRoute
  '/asset-binder/': typeof AssetBinderIndexRoute
  '/asset_collection/': typeof Asset_collectionIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/ground-truth/': typeof GroundTruthIndexRoute
  '/iata-binder/': typeof IataBinderIndexRoute
  '/lease/': typeof LeaseIndexRoute
  '/line_items/': typeof Line_itemsIndexRoute
  '/removal_installation_list/': typeof Removal_installation_listIndexRoute
  '/transition-360/': typeof Transition360IndexRoute
  '/aircrafts/$aircraftId/work-order-upload': typeof AircraftsAircraftIdWorkOrderUploadRoute
  '/ground-truth/$ingestedFileId/pages': typeof GroundTruthIngestedFileIdPagesRoute
  '/ground-truth/$ingestedFileId/sheets': typeof GroundTruthIngestedFileIdSheetsRoute
  '/aircrafts/$aircraftId/': typeof AircraftsAircraftIdIndexRoute
  '/documents/duplicate-review/': typeof DocumentsDuplicateReviewIndexRoute
  '/documents/upload/': typeof DocumentsUploadIndexRoute
  '/ground-truth/$ingestedFileId/': typeof GroundTruthIngestedFileIdIndexRoute
  '/line_items/$lineItemId/': typeof Line_itemsLineItemIdIndexRoute
  '/removal_installation_list/$componentActivityId/': typeof Removal_installation_listComponentActivityIdIndexRoute
  '/ground-truth/$ingestedFileId/$docId/rows': typeof GroundTruthIngestedFileIdDocIdRowsRoute
  '/iata-binder/projects/$projectId/page': typeof IataBinderProjectsProjectIdPageRoute
  '/iata-binder/projects/$projectId/upload': typeof IataBinderProjectsProjectIdUploadRoute
  '/lease/documents/$documentId/page': typeof LeaseDocumentsDocumentIdPageRoute
  '/lease/projects/$projectId/ad-table': typeof LeaseProjectsProjectIdAdTableRoute
  '/lease/projects/$projectId/aircraft-folder': typeof LeaseProjectsProjectIdAircraftFolderRoute
  '/lease/projects/$projectId/page': typeof LeaseProjectsProjectIdPageRoute
  '/lease/projects/$projectId/reports': typeof LeaseProjectsProjectIdReportsRoute
  '/asset_collection/$collectionId/assets/': typeof Asset_collectionCollectionIdAssetsIndexRoute
  '/asset_collection/assets/$assetId/': typeof Asset_collectionAssetsAssetIdIndexRoute
  '/documents/duplicate-review/$id/': typeof DocumentsDuplicateReviewIdIndexRoute
  '/ground-truth/$ingestedFileId/$docId/': typeof GroundTruthIngestedFileIdDocIdIndexRoute
  '/transition-360/projects/$projectId/': typeof Transition360ProjectsProjectIdIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteWithChildren
  '/transition-360/projects/$projectId/documents/$documentId': typeof Transition360ProjectsProjectIdDocumentsDocumentIdRoute
  '/aircrafts/$aircraftId/work_orders/$workOrderId/': typeof AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute
  '/iata-binder/projects/$projectId/ad-report/': typeof IataBinderProjectsProjectIdAdReportIndexRoute
  '/lease/projects/$projectId/documents/': typeof LeaseProjectsProjectIdDocumentsIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/edit-asset': typeof Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute
  '/lease/projects/$projectId/components/$partNumber/page': typeof LeaseProjectsProjectIdComponentsPartNumberPageRoute
  '/lease/projects/$projectId/documents/$documentId/page': typeof LeaseProjectsProjectIdDocumentsDocumentIdPageRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/binder': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/labels': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/open-items': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/repository': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute
  '/asset_collection/assets/$assetId/projects/$projectId/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute
  '/iata-binder/projects/$projectId/btb/$serialNumber/': typeof IataBinderProjectsProjectIdBtbSerialNumberIndexRoute
  '/iata-binder/projects/$projectId/folders/$folderLetter/': typeof IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute
  '/lease/projects/$projectId/folders/$folderLetter/': typeof LeaseProjectsProjectIdFoldersFolderLetterIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute
  '/asset_collection/assets/$assetId/projects/$projectId/search/$docId': typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/search/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute
  '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/': typeof IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  '/lease/projects/$projectId/folders/$folderLetter/subfolder/': typeof LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/': typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/': typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
  '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/': typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/transition-360'
    | '/approved'
    | '/auth'
    | '/coming-soon'
    | '/feedback'
    | '/file-overview'
    | '/job-queue'
    | '/meta-search'
    | '/pending'
    | '/settings'
    | '/system'
    | '/teams'
    | '/asset_collection/create_asset'
    | '/documents/ingestion-funnel'
    | '/ground-truth/fields'
    | '/ground-truth/snapshots'
    | '/lease/add-contract'
    | '/lease/aircraft'
    | '/lease/connect-api'
    | '/lease/create-project'
    | '/aircrafts/'
    | '/asset-binder/'
    | '/asset_collection/'
    | '/documents/'
    | '/ground-truth/'
    | '/iata-binder/'
    | '/lease/'
    | '/line_items/'
    | '/removal_installation_list/'
    | '/transition-360/'
    | '/aircrafts/$aircraftId/work-order-upload'
    | '/ground-truth/$ingestedFileId/pages'
    | '/ground-truth/$ingestedFileId/sheets'
    | '/aircrafts/$aircraftId/'
    | '/documents/duplicate-review/'
    | '/documents/upload/'
    | '/ground-truth/$ingestedFileId/'
    | '/line_items/$lineItemId/'
    | '/removal_installation_list/$componentActivityId/'
    | '/ground-truth/$ingestedFileId/$docId/rows'
    | '/iata-binder/projects/$projectId/page'
    | '/iata-binder/projects/$projectId/upload'
    | '/lease/documents/$documentId/page'
    | '/lease/projects/$projectId/ad-table'
    | '/lease/projects/$projectId/aircraft-folder'
    | '/lease/projects/$projectId/page'
    | '/lease/projects/$projectId/reports'
    | '/asset_collection/$collectionId/assets/'
    | '/asset_collection/assets/$assetId/'
    | '/documents/duplicate-review/$id/'
    | '/ground-truth/$ingestedFileId/$docId/'
    | '/transition-360/projects/$projectId/'
    | '/transition-360/projects/$projectId/assets/$projectAssetId'
    | '/transition-360/projects/$projectId/documents/$documentId'
    | '/aircrafts/$aircraftId/work_orders/$workOrderId/'
    | '/iata-binder/projects/$projectId/ad-report/'
    | '/lease/projects/$projectId/documents/'
    | '/asset_collection/assets/$assetId/projects/$projectId/edit-asset'
    | '/lease/projects/$projectId/components/$partNumber/page'
    | '/lease/projects/$projectId/documents/$documentId/page'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/binder'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/labels'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/open-items'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/repository'
    | '/asset_collection/assets/$assetId/projects/$projectId/'
    | '/iata-binder/projects/$projectId/btb/$serialNumber/'
    | '/iata-binder/projects/$projectId/folders/$folderLetter/'
    | '/lease/projects/$projectId/folders/$folderLetter/'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset'
    | '/asset_collection/assets/$assetId/projects/$projectId/search/$docId'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/'
    | '/asset_collection/assets/$assetId/projects/$projectId/search/'
    | '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/'
    | '/lease/projects/$projectId/folders/$folderLetter/subfolder/'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/approved'
    | '/auth'
    | '/coming-soon'
    | '/feedback'
    | '/file-overview'
    | '/job-queue'
    | '/meta-search'
    | '/pending'
    | '/settings'
    | '/system'
    | '/teams'
    | '/asset_collection/create_asset'
    | '/documents/ingestion-funnel'
    | '/ground-truth/fields'
    | '/ground-truth/snapshots'
    | '/lease/add-contract'
    | '/lease/aircraft'
    | '/lease/connect-api'
    | '/lease/create-project'
    | '/aircrafts'
    | '/asset-binder'
    | '/asset_collection'
    | '/documents'
    | '/ground-truth'
    | '/iata-binder'
    | '/lease'
    | '/line_items'
    | '/removal_installation_list'
    | '/transition-360'
    | '/aircrafts/$aircraftId/work-order-upload'
    | '/ground-truth/$ingestedFileId/pages'
    | '/ground-truth/$ingestedFileId/sheets'
    | '/aircrafts/$aircraftId'
    | '/documents/duplicate-review'
    | '/documents/upload'
    | '/ground-truth/$ingestedFileId'
    | '/line_items/$lineItemId'
    | '/removal_installation_list/$componentActivityId'
    | '/ground-truth/$ingestedFileId/$docId/rows'
    | '/iata-binder/projects/$projectId/page'
    | '/iata-binder/projects/$projectId/upload'
    | '/lease/documents/$documentId/page'
    | '/lease/projects/$projectId/ad-table'
    | '/lease/projects/$projectId/aircraft-folder'
    | '/lease/projects/$projectId/page'
    | '/lease/projects/$projectId/reports'
    | '/asset_collection/$collectionId/assets'
    | '/asset_collection/assets/$assetId'
    | '/documents/duplicate-review/$id'
    | '/ground-truth/$ingestedFileId/$docId'
    | '/transition-360/projects/$projectId'
    | '/transition-360/projects/$projectId/documents/$documentId'
    | '/aircrafts/$aircraftId/work_orders/$workOrderId'
    | '/iata-binder/projects/$projectId/ad-report'
    | '/lease/projects/$projectId/documents'
    | '/asset_collection/assets/$assetId/projects/$projectId/edit-asset'
    | '/lease/projects/$projectId/components/$partNumber/page'
    | '/lease/projects/$projectId/documents/$documentId/page'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/binder'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/labels'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/open-items'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/repository'
    | '/asset_collection/assets/$assetId/projects/$projectId'
    | '/iata-binder/projects/$projectId/btb/$serialNumber'
    | '/iata-binder/projects/$projectId/folders/$folderLetter'
    | '/lease/projects/$projectId/folders/$folderLetter'
    | '/transition-360/projects/$projectId/assets/$projectAssetId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset'
    | '/asset_collection/assets/$assetId/projects/$projectId/search/$docId'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId'
    | '/asset_collection/assets/$assetId/projects/$projectId/search'
    | '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder'
    | '/lease/projects/$projectId/folders/$folderLetter/subfolder'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId'
  id:
    | '__root__'
    | '/'
    | '/transition-360'
    | '/approved'
    | '/auth'
    | '/coming-soon'
    | '/feedback'
    | '/file-overview'
    | '/job-queue'
    | '/meta-search'
    | '/pending'
    | '/settings'
    | '/system'
    | '/teams'
    | '/asset_collection/create_asset'
    | '/documents/ingestion-funnel'
    | '/ground-truth/fields'
    | '/ground-truth/snapshots'
    | '/lease/add-contract'
    | '/lease/aircraft'
    | '/lease/connect-api'
    | '/lease/create-project'
    | '/aircrafts/'
    | '/asset-binder/'
    | '/asset_collection/'
    | '/documents/'
    | '/ground-truth/'
    | '/iata-binder/'
    | '/lease/'
    | '/line_items/'
    | '/removal_installation_list/'
    | '/transition-360/'
    | '/aircrafts/$aircraftId/work-order-upload'
    | '/ground-truth/$ingestedFileId/pages'
    | '/ground-truth/$ingestedFileId/sheets'
    | '/aircrafts/$aircraftId/'
    | '/documents/duplicate-review/'
    | '/documents/upload/'
    | '/ground-truth/$ingestedFileId/'
    | '/line_items/$lineItemId/'
    | '/removal_installation_list/$componentActivityId/'
    | '/ground-truth/$ingestedFileId/$docId/rows'
    | '/iata-binder/projects/$projectId/page'
    | '/iata-binder/projects/$projectId/upload'
    | '/lease/documents/$documentId/page'
    | '/lease/projects/$projectId/ad-table'
    | '/lease/projects/$projectId/aircraft-folder'
    | '/lease/projects/$projectId/page'
    | '/lease/projects/$projectId/reports'
    | '/asset_collection/$collectionId/assets/'
    | '/asset_collection/assets/$assetId/'
    | '/documents/duplicate-review/$id/'
    | '/ground-truth/$ingestedFileId/$docId/'
    | '/transition-360/projects/$projectId/'
    | '/transition-360/projects/$projectId/assets/$projectAssetId'
    | '/transition-360/projects/$projectId/documents/$documentId'
    | '/aircrafts/$aircraftId/work_orders/$workOrderId/'
    | '/iata-binder/projects/$projectId/ad-report/'
    | '/lease/projects/$projectId/documents/'
    | '/asset_collection/assets/$assetId/projects/$projectId/edit-asset'
    | '/lease/projects/$projectId/components/$partNumber/page'
    | '/lease/projects/$projectId/documents/$documentId/page'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/binder'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/labels'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/open-items'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/repository'
    | '/asset_collection/assets/$assetId/projects/$projectId/'
    | '/iata-binder/projects/$projectId/btb/$serialNumber/'
    | '/iata-binder/projects/$projectId/folders/$folderLetter/'
    | '/lease/projects/$projectId/folders/$folderLetter/'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset'
    | '/asset_collection/assets/$assetId/projects/$projectId/search/$docId'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/'
    | '/asset_collection/assets/$assetId/projects/$projectId/search/'
    | '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/'
    | '/lease/projects/$projectId/folders/$folderLetter/subfolder/'
    | '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
    | '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
    | '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  Transition360RouteRoute: typeof Transition360RouteRouteWithChildren
  ApprovedRoute: typeof ApprovedRoute
  AuthRoute: typeof AuthRoute
  ComingSoonRoute: typeof ComingSoonRoute
  FeedbackRoute: typeof FeedbackRoute
  FileOverviewRoute: typeof FileOverviewRoute
  JobQueueRoute: typeof JobQueueRoute
  MetaSearchRoute: typeof MetaSearchRoute
  PendingRoute: typeof PendingRoute
  SettingsRoute: typeof SettingsRoute
  SystemRoute: typeof SystemRoute
  TeamsRoute: typeof TeamsRoute
  Asset_collectionCreate_assetRoute: typeof Asset_collectionCreate_assetRoute
  DocumentsIngestionFunnelRoute: typeof DocumentsIngestionFunnelRoute
  GroundTruthFieldsRoute: typeof GroundTruthFieldsRoute
  GroundTruthSnapshotsRoute: typeof GroundTruthSnapshotsRoute
  LeaseAddContractRoute: typeof LeaseAddContractRoute
  LeaseAircraftRoute: typeof LeaseAircraftRoute
  LeaseConnectApiRoute: typeof LeaseConnectApiRoute
  LeaseCreateProjectRoute: typeof LeaseCreateProjectRoute
  AircraftsIndexRoute: typeof AircraftsIndexRoute
  AssetBinderIndexRoute: typeof AssetBinderIndexRoute
  Asset_collectionIndexRoute: typeof Asset_collectionIndexRoute
  DocumentsIndexRoute: typeof DocumentsIndexRoute
  GroundTruthIndexRoute: typeof GroundTruthIndexRoute
  IataBinderIndexRoute: typeof IataBinderIndexRoute
  LeaseIndexRoute: typeof LeaseIndexRoute
  Line_itemsIndexRoute: typeof Line_itemsIndexRoute
  Removal_installation_listIndexRoute: typeof Removal_installation_listIndexRoute
  AircraftsAircraftIdWorkOrderUploadRoute: typeof AircraftsAircraftIdWorkOrderUploadRoute
  GroundTruthIngestedFileIdPagesRoute: typeof GroundTruthIngestedFileIdPagesRoute
  GroundTruthIngestedFileIdSheetsRoute: typeof GroundTruthIngestedFileIdSheetsRoute
  AircraftsAircraftIdIndexRoute: typeof AircraftsAircraftIdIndexRoute
  DocumentsDuplicateReviewIndexRoute: typeof DocumentsDuplicateReviewIndexRoute
  DocumentsUploadIndexRoute: typeof DocumentsUploadIndexRoute
  GroundTruthIngestedFileIdIndexRoute: typeof GroundTruthIngestedFileIdIndexRoute
  Line_itemsLineItemIdIndexRoute: typeof Line_itemsLineItemIdIndexRoute
  Removal_installation_listComponentActivityIdIndexRoute: typeof Removal_installation_listComponentActivityIdIndexRoute
  GroundTruthIngestedFileIdDocIdRowsRoute: typeof GroundTruthIngestedFileIdDocIdRowsRoute
  IataBinderProjectsProjectIdPageRoute: typeof IataBinderProjectsProjectIdPageRoute
  IataBinderProjectsProjectIdUploadRoute: typeof IataBinderProjectsProjectIdUploadRoute
  LeaseDocumentsDocumentIdPageRoute: typeof LeaseDocumentsDocumentIdPageRoute
  LeaseProjectsProjectIdAdTableRoute: typeof LeaseProjectsProjectIdAdTableRoute
  LeaseProjectsProjectIdAircraftFolderRoute: typeof LeaseProjectsProjectIdAircraftFolderRoute
  LeaseProjectsProjectIdPageRoute: typeof LeaseProjectsProjectIdPageRoute
  LeaseProjectsProjectIdReportsRoute: typeof LeaseProjectsProjectIdReportsRoute
  Asset_collectionCollectionIdAssetsIndexRoute: typeof Asset_collectionCollectionIdAssetsIndexRoute
  Asset_collectionAssetsAssetIdIndexRoute: typeof Asset_collectionAssetsAssetIdIndexRoute
  DocumentsDuplicateReviewIdIndexRoute: typeof DocumentsDuplicateReviewIdIndexRoute
  GroundTruthIngestedFileIdDocIdIndexRoute: typeof GroundTruthIngestedFileIdDocIdIndexRoute
  AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute: typeof AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute
  IataBinderProjectsProjectIdAdReportIndexRoute: typeof IataBinderProjectsProjectIdAdReportIndexRoute
  LeaseProjectsProjectIdDocumentsIndexRoute: typeof LeaseProjectsProjectIdDocumentsIndexRoute
  Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute
  LeaseProjectsProjectIdComponentsPartNumberPageRoute: typeof LeaseProjectsProjectIdComponentsPartNumberPageRoute
  LeaseProjectsProjectIdDocumentsDocumentIdPageRoute: typeof LeaseProjectsProjectIdDocumentsDocumentIdPageRoute
  Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute
  IataBinderProjectsProjectIdBtbSerialNumberIndexRoute: typeof IataBinderProjectsProjectIdBtbSerialNumberIndexRoute
  IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute: typeof IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute
  LeaseProjectsProjectIdFoldersFolderLetterIndexRoute: typeof LeaseProjectsProjectIdFoldersFolderLetterIndexRoute
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute
  Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute
  Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute
  IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute: typeof IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute: typeof LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approved': {
      id: '/approved'
      path: '/approved'
      fullPath: '/approved'
      preLoaderRoute: typeof ApprovedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon': {
      id: '/coming-soon'
      path: '/coming-soon'
      fullPath: '/coming-soon'
      preLoaderRoute: typeof ComingSoonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/file-overview': {
      id: '/file-overview'
      path: '/file-overview'
      fullPath: '/file-overview'
      preLoaderRoute: typeof FileOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job-queue': {
      id: '/job-queue'
      path: '/job-queue'
      fullPath: '/job-queue'
      preLoaderRoute: typeof JobQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meta-search': {
      id: '/meta-search'
      path: '/meta-search'
      fullPath: '/meta-search'
      preLoaderRoute: typeof MetaSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending': {
      id: '/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof PendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system': {
      id: '/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof SystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams': {
      id: '/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof TeamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transition-360': {
      id: '/transition-360'
      path: '/transition-360'
      fullPath: '/transition-360'
      preLoaderRoute: typeof Transition360RouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aircrafts/': {
      id: '/aircrafts/'
      path: '/aircrafts'
      fullPath: '/aircrafts/'
      preLoaderRoute: typeof AircraftsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-binder/': {
      id: '/asset-binder/'
      path: '/asset-binder'
      fullPath: '/asset-binder/'
      preLoaderRoute: typeof AssetBinderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/': {
      id: '/asset_collection/'
      path: '/asset_collection'
      fullPath: '/asset_collection/'
      preLoaderRoute: typeof Asset_collectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/create_asset': {
      id: '/asset_collection/create_asset'
      path: '/asset_collection/create_asset'
      fullPath: '/asset_collection/create_asset'
      preLoaderRoute: typeof Asset_collectionCreate_assetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/': {
      id: '/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/ingestion-funnel': {
      id: '/documents/ingestion-funnel'
      path: '/documents/ingestion-funnel'
      fullPath: '/documents/ingestion-funnel'
      preLoaderRoute: typeof DocumentsIngestionFunnelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/': {
      id: '/ground-truth/'
      path: '/ground-truth'
      fullPath: '/ground-truth/'
      preLoaderRoute: typeof GroundTruthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/fields': {
      id: '/ground-truth/fields'
      path: '/ground-truth/fields'
      fullPath: '/ground-truth/fields'
      preLoaderRoute: typeof GroundTruthFieldsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/snapshots': {
      id: '/ground-truth/snapshots'
      path: '/ground-truth/snapshots'
      fullPath: '/ground-truth/snapshots'
      preLoaderRoute: typeof GroundTruthSnapshotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iata-binder/': {
      id: '/iata-binder/'
      path: '/iata-binder'
      fullPath: '/iata-binder/'
      preLoaderRoute: typeof IataBinderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/': {
      id: '/lease/'
      path: '/lease'
      fullPath: '/lease/'
      preLoaderRoute: typeof LeaseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/add-contract': {
      id: '/lease/add-contract'
      path: '/lease/add-contract'
      fullPath: '/lease/add-contract'
      preLoaderRoute: typeof LeaseAddContractRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/aircraft': {
      id: '/lease/aircraft'
      path: '/lease/aircraft'
      fullPath: '/lease/aircraft'
      preLoaderRoute: typeof LeaseAircraftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/connect-api': {
      id: '/lease/connect-api'
      path: '/lease/connect-api'
      fullPath: '/lease/connect-api'
      preLoaderRoute: typeof LeaseConnectApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/create-project': {
      id: '/lease/create-project'
      path: '/lease/create-project'
      fullPath: '/lease/create-project'
      preLoaderRoute: typeof LeaseCreateProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/line_items/': {
      id: '/line_items/'
      path: '/line_items'
      fullPath: '/line_items/'
      preLoaderRoute: typeof Line_itemsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/removal_installation_list/': {
      id: '/removal_installation_list/'
      path: '/removal_installation_list'
      fullPath: '/removal_installation_list/'
      preLoaderRoute: typeof Removal_installation_listIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transition-360/': {
      id: '/transition-360/'
      path: '/'
      fullPath: '/transition-360/'
      preLoaderRoute: typeof Transition360IndexRouteImport
      parentRoute: typeof Transition360RouteRoute
    }
    '/aircrafts/$aircraftId/': {
      id: '/aircrafts/$aircraftId/'
      path: '/aircrafts/$aircraftId'
      fullPath: '/aircrafts/$aircraftId/'
      preLoaderRoute: typeof AircraftsAircraftIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aircrafts/$aircraftId/work-order-upload': {
      id: '/aircrafts/$aircraftId/work-order-upload'
      path: '/aircrafts/$aircraftId/work-order-upload'
      fullPath: '/aircrafts/$aircraftId/work-order-upload'
      preLoaderRoute: typeof AircraftsAircraftIdWorkOrderUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/duplicate-review/': {
      id: '/documents/duplicate-review/'
      path: '/documents/duplicate-review'
      fullPath: '/documents/duplicate-review/'
      preLoaderRoute: typeof DocumentsDuplicateReviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/upload/': {
      id: '/documents/upload/'
      path: '/documents/upload'
      fullPath: '/documents/upload/'
      preLoaderRoute: typeof DocumentsUploadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/$ingestedFileId/': {
      id: '/ground-truth/$ingestedFileId/'
      path: '/ground-truth/$ingestedFileId'
      fullPath: '/ground-truth/$ingestedFileId/'
      preLoaderRoute: typeof GroundTruthIngestedFileIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/$ingestedFileId/pages': {
      id: '/ground-truth/$ingestedFileId/pages'
      path: '/ground-truth/$ingestedFileId/pages'
      fullPath: '/ground-truth/$ingestedFileId/pages'
      preLoaderRoute: typeof GroundTruthIngestedFileIdPagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/$ingestedFileId/sheets': {
      id: '/ground-truth/$ingestedFileId/sheets'
      path: '/ground-truth/$ingestedFileId/sheets'
      fullPath: '/ground-truth/$ingestedFileId/sheets'
      preLoaderRoute: typeof GroundTruthIngestedFileIdSheetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/line_items/$lineItemId/': {
      id: '/line_items/$lineItemId/'
      path: '/line_items/$lineItemId'
      fullPath: '/line_items/$lineItemId/'
      preLoaderRoute: typeof Line_itemsLineItemIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/removal_installation_list/$componentActivityId/': {
      id: '/removal_installation_list/$componentActivityId/'
      path: '/removal_installation_list/$componentActivityId'
      fullPath: '/removal_installation_list/$componentActivityId/'
      preLoaderRoute: typeof Removal_installation_listComponentActivityIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/$collectionId/assets/': {
      id: '/asset_collection/$collectionId/assets/'
      path: '/asset_collection/$collectionId/assets'
      fullPath: '/asset_collection/$collectionId/assets/'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/assets/$assetId/': {
      id: '/asset_collection/assets/$assetId/'
      path: '/asset_collection/assets/$assetId'
      fullPath: '/asset_collection/assets/$assetId/'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/duplicate-review/$id/': {
      id: '/documents/duplicate-review/$id/'
      path: '/documents/duplicate-review/$id'
      fullPath: '/documents/duplicate-review/$id/'
      preLoaderRoute: typeof DocumentsDuplicateReviewIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/$ingestedFileId/$docId/': {
      id: '/ground-truth/$ingestedFileId/$docId/'
      path: '/ground-truth/$ingestedFileId/$docId'
      fullPath: '/ground-truth/$ingestedFileId/$docId/'
      preLoaderRoute: typeof GroundTruthIngestedFileIdDocIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ground-truth/$ingestedFileId/$docId/rows': {
      id: '/ground-truth/$ingestedFileId/$docId/rows'
      path: '/ground-truth/$ingestedFileId/$docId/rows'
      fullPath: '/ground-truth/$ingestedFileId/$docId/rows'
      preLoaderRoute: typeof GroundTruthIngestedFileIdDocIdRowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iata-binder/projects/$projectId/page': {
      id: '/iata-binder/projects/$projectId/page'
      path: '/iata-binder/projects/$projectId/page'
      fullPath: '/iata-binder/projects/$projectId/page'
      preLoaderRoute: typeof IataBinderProjectsProjectIdPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iata-binder/projects/$projectId/upload': {
      id: '/iata-binder/projects/$projectId/upload'
      path: '/iata-binder/projects/$projectId/upload'
      fullPath: '/iata-binder/projects/$projectId/upload'
      preLoaderRoute: typeof IataBinderProjectsProjectIdUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/documents/$documentId/page': {
      id: '/lease/documents/$documentId/page'
      path: '/lease/documents/$documentId/page'
      fullPath: '/lease/documents/$documentId/page'
      preLoaderRoute: typeof LeaseDocumentsDocumentIdPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/ad-table': {
      id: '/lease/projects/$projectId/ad-table'
      path: '/lease/projects/$projectId/ad-table'
      fullPath: '/lease/projects/$projectId/ad-table'
      preLoaderRoute: typeof LeaseProjectsProjectIdAdTableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/aircraft-folder': {
      id: '/lease/projects/$projectId/aircraft-folder'
      path: '/lease/projects/$projectId/aircraft-folder'
      fullPath: '/lease/projects/$projectId/aircraft-folder'
      preLoaderRoute: typeof LeaseProjectsProjectIdAircraftFolderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/page': {
      id: '/lease/projects/$projectId/page'
      path: '/lease/projects/$projectId/page'
      fullPath: '/lease/projects/$projectId/page'
      preLoaderRoute: typeof LeaseProjectsProjectIdPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/reports': {
      id: '/lease/projects/$projectId/reports'
      path: '/lease/projects/$projectId/reports'
      fullPath: '/lease/projects/$projectId/reports'
      preLoaderRoute: typeof LeaseProjectsProjectIdReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transition-360/projects/$projectId/': {
      id: '/transition-360/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/transition-360/projects/$projectId/'
      preLoaderRoute: typeof Transition360ProjectsProjectIdIndexRouteImport
      parentRoute: typeof Transition360RouteRoute
    }
    '/aircrafts/$aircraftId/work_orders/$workOrderId/': {
      id: '/aircrafts/$aircraftId/work_orders/$workOrderId/'
      path: '/aircrafts/$aircraftId/work_orders/$workOrderId'
      fullPath: '/aircrafts/$aircraftId/work_orders/$workOrderId/'
      preLoaderRoute: typeof AircraftsAircraftIdWork_ordersWorkOrderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iata-binder/projects/$projectId/ad-report/': {
      id: '/iata-binder/projects/$projectId/ad-report/'
      path: '/iata-binder/projects/$projectId/ad-report'
      fullPath: '/iata-binder/projects/$projectId/ad-report/'
      preLoaderRoute: typeof IataBinderProjectsProjectIdAdReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/documents/': {
      id: '/lease/projects/$projectId/documents/'
      path: '/lease/projects/$projectId/documents'
      fullPath: '/lease/projects/$projectId/documents/'
      preLoaderRoute: typeof LeaseProjectsProjectIdDocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId'
      path: '/projects/$projectId/assets/$projectAssetId'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteImport
      parentRoute: typeof Transition360RouteRoute
    }
    '/transition-360/projects/$projectId/documents/$documentId': {
      id: '/transition-360/projects/$projectId/documents/$documentId'
      path: '/projects/$projectId/documents/$documentId'
      fullPath: '/transition-360/projects/$projectId/documents/$documentId'
      preLoaderRoute: typeof Transition360ProjectsProjectIdDocumentsDocumentIdRouteImport
      parentRoute: typeof Transition360RouteRoute
    }
    '/asset_collection/assets/$assetId/projects/$projectId/': {
      id: '/asset_collection/assets/$assetId/projects/$projectId/'
      path: '/asset_collection/assets/$assetId/projects/$projectId'
      fullPath: '/asset_collection/assets/$assetId/projects/$projectId/'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/assets/$assetId/projects/$projectId/edit-asset': {
      id: '/asset_collection/assets/$assetId/projects/$projectId/edit-asset'
      path: '/asset_collection/assets/$assetId/projects/$projectId/edit-asset'
      fullPath: '/asset_collection/assets/$assetId/projects/$projectId/edit-asset'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iata-binder/projects/$projectId/btb/$serialNumber/': {
      id: '/iata-binder/projects/$projectId/btb/$serialNumber/'
      path: '/iata-binder/projects/$projectId/btb/$serialNumber'
      fullPath: '/iata-binder/projects/$projectId/btb/$serialNumber/'
      preLoaderRoute: typeof IataBinderProjectsProjectIdBtbSerialNumberIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iata-binder/projects/$projectId/folders/$folderLetter/': {
      id: '/iata-binder/projects/$projectId/folders/$folderLetter/'
      path: '/iata-binder/projects/$projectId/folders/$folderLetter'
      fullPath: '/iata-binder/projects/$projectId/folders/$folderLetter/'
      preLoaderRoute: typeof IataBinderProjectsProjectIdFoldersFolderLetterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/components/$partNumber/page': {
      id: '/lease/projects/$projectId/components/$partNumber/page'
      path: '/lease/projects/$projectId/components/$partNumber/page'
      fullPath: '/lease/projects/$projectId/components/$partNumber/page'
      preLoaderRoute: typeof LeaseProjectsProjectIdComponentsPartNumberPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/documents/$documentId/page': {
      id: '/lease/projects/$projectId/documents/$documentId/page'
      path: '/lease/projects/$projectId/documents/$documentId/page'
      fullPath: '/lease/projects/$projectId/documents/$documentId/page'
      preLoaderRoute: typeof LeaseProjectsProjectIdDocumentsDocumentIdPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/folders/$folderLetter/': {
      id: '/lease/projects/$projectId/folders/$folderLetter/'
      path: '/lease/projects/$projectId/folders/$folderLetter'
      fullPath: '/lease/projects/$projectId/folders/$folderLetter/'
      preLoaderRoute: typeof LeaseProjectsProjectIdFoldersFolderLetterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId/': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId/'
      path: '/'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId/'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRouteImport
      parentRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId/binder': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId/binder'
      path: '/binder'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId/binder'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRouteImport
      parentRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId/labels': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId/labels'
      path: '/labels'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId/labels'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRouteImport
      parentRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId/open-items': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId/open-items'
      path: '/open-items'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId/open-items'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRouteImport
      parentRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId/repository': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId/repository'
      path: '/repository'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId/repository'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRouteImport
      parentRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute
    }
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/': {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/'
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId'
      fullPath: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset': {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset'
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset'
      fullPath: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/assets/$assetId/projects/$projectId/search/': {
      id: '/asset_collection/assets/$assetId/projects/$projectId/search/'
      path: '/asset_collection/assets/$assetId/projects/$projectId/search'
      fullPath: '/asset_collection/assets/$assetId/projects/$projectId/search/'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/assets/$assetId/projects/$projectId/search/$docId': {
      id: '/asset_collection/assets/$assetId/projects/$projectId/search/$docId'
      path: '/asset_collection/assets/$assetId/projects/$projectId/search/$docId'
      fullPath: '/asset_collection/assets/$assetId/projects/$projectId/search/$docId'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/': {
      id: '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/'
      path: '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder'
      fullPath: '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/'
      preLoaderRoute: typeof IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lease/projects/$projectId/folders/$folderLetter/subfolder/': {
      id: '/lease/projects/$projectId/folders/$folderLetter/subfolder/'
      path: '/lease/projects/$projectId/folders/$folderLetter/subfolder'
      fullPath: '/lease/projects/$projectId/folders/$folderLetter/subfolder/'
      preLoaderRoute: typeof LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/'
      path: '/status-reports'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRouteImport
      parentRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute
    }
    '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId': {
      id: '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId'
      path: '/status-reports/$statusReportId'
      fullPath: '/transition-360/projects/$projectId/assets/$projectAssetId/status-reports/$statusReportId'
      preLoaderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRouteImport
      parentRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute
    }
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/': {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/'
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search'
      fullPath: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId': {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId'
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId'
      fullPath: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/search/$docId'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/': {
      id: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/'
      path: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter'
      fullPath: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/': {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/'
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter'
      fullPath: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/': {
      id: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
      path: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType'
      fullPath: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/': {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType'
      fullPath: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/': {
      id: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
      path: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId'
      fullPath: '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
      preLoaderRoute: typeof Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/': {
      id: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
      path: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId'
      fullPath: '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/'
      preLoaderRoute: typeof Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteChildren {
  Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute
  Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute
  Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute
  Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute
  Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute
  Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute
  Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute
}

const Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteChildren: Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteChildren =
  {
    Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute:
      Transition360ProjectsProjectIdAssetsProjectAssetIdBinderRoute,
    Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute:
      Transition360ProjectsProjectIdAssetsProjectAssetIdLabelsRoute,
    Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute:
      Transition360ProjectsProjectIdAssetsProjectAssetIdOpenItemsRoute,
    Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute:
      Transition360ProjectsProjectIdAssetsProjectAssetIdRepositoryRoute,
    Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute:
      Transition360ProjectsProjectIdAssetsProjectAssetIdIndexRoute,
    Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute:
      Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsStatusReportIdRoute,
    Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute:
      Transition360ProjectsProjectIdAssetsProjectAssetIdStatusReportsIndexRoute,
  }

const Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteWithChildren =
  Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute._addFileChildren(
    Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteChildren,
  )

interface Transition360RouteRouteChildren {
  Transition360IndexRoute: typeof Transition360IndexRoute
  Transition360ProjectsProjectIdIndexRoute: typeof Transition360ProjectsProjectIdIndexRoute
  Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute: typeof Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteWithChildren
  Transition360ProjectsProjectIdDocumentsDocumentIdRoute: typeof Transition360ProjectsProjectIdDocumentsDocumentIdRoute
}

const Transition360RouteRouteChildren: Transition360RouteRouteChildren = {
  Transition360IndexRoute: Transition360IndexRoute,
  Transition360ProjectsProjectIdIndexRoute:
    Transition360ProjectsProjectIdIndexRoute,
  Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRoute:
    Transition360ProjectsProjectIdAssetsProjectAssetIdRouteRouteWithChildren,
  Transition360ProjectsProjectIdDocumentsDocumentIdRoute:
    Transition360ProjectsProjectIdDocumentsDocumentIdRoute,
}

const Transition360RouteRouteWithChildren =
  Transition360RouteRoute._addFileChildren(Transition360RouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Transition360RouteRoute: Transition360RouteRouteWithChildren,
  ApprovedRoute: ApprovedRoute,
  AuthRoute: AuthRoute,
  ComingSoonRoute: ComingSoonRoute,
  FeedbackRoute: FeedbackRoute,
  FileOverviewRoute: FileOverviewRoute,
  JobQueueRoute: JobQueueRoute,
  MetaSearchRoute: MetaSearchRoute,
  PendingRoute: PendingRoute,
  SettingsRoute: SettingsRoute,
  SystemRoute: SystemRoute,
  TeamsRoute: TeamsRoute,
  Asset_collectionCreate_assetRoute: Asset_collectionCreate_assetRoute,
  DocumentsIngestionFunnelRoute: DocumentsIngestionFunnelRoute,
  GroundTruthFieldsRoute: GroundTruthFieldsRoute,
  GroundTruthSnapshotsRoute: GroundTruthSnapshotsRoute,
  LeaseAddContractRoute: LeaseAddContractRoute,
  LeaseAircraftRoute: LeaseAircraftRoute,
  LeaseConnectApiRoute: LeaseConnectApiRoute,
  LeaseCreateProjectRoute: LeaseCreateProjectRoute,
  AircraftsIndexRoute: AircraftsIndexRoute,
  AssetBinderIndexRoute: AssetBinderIndexRoute,
  Asset_collectionIndexRoute: Asset_collectionIndexRoute,
  DocumentsIndexRoute: DocumentsIndexRoute,
  GroundTruthIndexRoute: GroundTruthIndexRoute,
  IataBinderIndexRoute: IataBinderIndexRoute,
  LeaseIndexRoute: LeaseIndexRoute,
  Line_itemsIndexRoute: Line_itemsIndexRoute,
  Removal_installation_listIndexRoute: Removal_installation_listIndexRoute,
  AircraftsAircraftIdWorkOrderUploadRoute:
    AircraftsAircraftIdWorkOrderUploadRoute,
  GroundTruthIngestedFileIdPagesRoute: GroundTruthIngestedFileIdPagesRoute,
  GroundTruthIngestedFileIdSheetsRoute: GroundTruthIngestedFileIdSheetsRoute,
  AircraftsAircraftIdIndexRoute: AircraftsAircraftIdIndexRoute,
  DocumentsDuplicateReviewIndexRoute: DocumentsDuplicateReviewIndexRoute,
  DocumentsUploadIndexRoute: DocumentsUploadIndexRoute,
  GroundTruthIngestedFileIdIndexRoute: GroundTruthIngestedFileIdIndexRoute,
  Line_itemsLineItemIdIndexRoute: Line_itemsLineItemIdIndexRoute,
  Removal_installation_listComponentActivityIdIndexRoute:
    Removal_installation_listComponentActivityIdIndexRoute,
  GroundTruthIngestedFileIdDocIdRowsRoute:
    GroundTruthIngestedFileIdDocIdRowsRoute,
  IataBinderProjectsProjectIdPageRoute: IataBinderProjectsProjectIdPageRoute,
  IataBinderProjectsProjectIdUploadRoute:
    IataBinderProjectsProjectIdUploadRoute,
  LeaseDocumentsDocumentIdPageRoute: LeaseDocumentsDocumentIdPageRoute,
  LeaseProjectsProjectIdAdTableRoute: LeaseProjectsProjectIdAdTableRoute,
  LeaseProjectsProjectIdAircraftFolderRoute:
    LeaseProjectsProjectIdAircraftFolderRoute,
  LeaseProjectsProjectIdPageRoute: LeaseProjectsProjectIdPageRoute,
  LeaseProjectsProjectIdReportsRoute: LeaseProjectsProjectIdReportsRoute,
  Asset_collectionCollectionIdAssetsIndexRoute:
    Asset_collectionCollectionIdAssetsIndexRoute,
  Asset_collectionAssetsAssetIdIndexRoute:
    Asset_collectionAssetsAssetIdIndexRoute,
  DocumentsDuplicateReviewIdIndexRoute: DocumentsDuplicateReviewIdIndexRoute,
  GroundTruthIngestedFileIdDocIdIndexRoute:
    GroundTruthIngestedFileIdDocIdIndexRoute,
  AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute:
    AircraftsAircraftIdWork_ordersWorkOrderIdIndexRoute,
  IataBinderProjectsProjectIdAdReportIndexRoute:
    IataBinderProjectsProjectIdAdReportIndexRoute,
  LeaseProjectsProjectIdDocumentsIndexRoute:
    LeaseProjectsProjectIdDocumentsIndexRoute,
  Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute:
    Asset_collectionAssetsAssetIdProjectsProjectIdEditAssetRoute,
  LeaseProjectsProjectIdComponentsPartNumberPageRoute:
    LeaseProjectsProjectIdComponentsPartNumberPageRoute,
  LeaseProjectsProjectIdDocumentsDocumentIdPageRoute:
    LeaseProjectsProjectIdDocumentsDocumentIdPageRoute,
  Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute:
    Asset_collectionAssetsAssetIdProjectsProjectIdIndexRoute,
  IataBinderProjectsProjectIdBtbSerialNumberIndexRoute:
    IataBinderProjectsProjectIdBtbSerialNumberIndexRoute,
  IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute:
    IataBinderProjectsProjectIdFoldersFolderLetterIndexRoute,
  LeaseProjectsProjectIdFoldersFolderLetterIndexRoute:
    LeaseProjectsProjectIdFoldersFolderLetterIndexRoute,
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute:
    Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdEditAssetRoute,
  Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute:
    Asset_collectionAssetsAssetIdProjectsProjectIdSearchDocIdRoute,
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute:
    Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdIndexRoute,
  Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute:
    Asset_collectionAssetsAssetIdProjectsProjectIdSearchIndexRoute,
  IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute:
    IataBinderProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute,
  LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute:
    LeaseProjectsProjectIdFoldersFolderLetterSubfolderIndexRoute,
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute:
    Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchDocIdRoute,
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute:
    Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdSearchIndexRoute,
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute:
    Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute,
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute:
    Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterIndexRoute,
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute:
    Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute,
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute:
    Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeIndexRoute,
  Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute:
    Asset_collectionAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute,
  Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute:
    Asset_collectionCollectionIdAssetsAssetIdProjectsProjectIdFoldersFolderLetterSubfoldersSubFolderTypeSubFolderIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
